/**
 * Cart Perfect Match – loader state for add-to-cart buttons.
 * Sets data-loading on submit, clears on cart:update / cart:error.
 */
(function () {
  const CART_UPDATE = 'cart:update';
  const CART_ERROR = 'cart:error';

  function clearLoading() {
    document.querySelectorAll('.cart-perfect-match__add[data-loading]').forEach((btn) => {
      btn.removeAttribute('data-loading');
    });
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
    const container = form.closest('.cart-perfect-match');
    if (!container) return;
    const btn = form.querySelector('.cart-perfect-match__add');
    if (btn) btn.setAttribute('data-loading', 'true');
  }, true);

  document.addEventListener(CART_UPDATE, clearLoading);
  document.addEventListener(CART_ERROR, clearLoading);
})();
